/*
账号管理页面相关api
 */
import md5 from 'js-md5';
import request from '../request';
export const accountManagementApi = {
  // 获取用户信息
  getUserInfo() {
    return request({
      url: '/user/user/info',
      method: 'get',
    });
  },
  getUserVip() {
    return request({
      url: '/gw/w/vip',
      method: 'get',
    });
  },
  // 获取Google秘钥（设置谷歌验证时使用）
  gaGenerate() {
    return request({
      url: '/user/get/ga',
      method: 'get',
    });
  },
  // 设置谷歌验证
  setGoogleVerify(data) {
    data.gaCode = data.gaCode.toString();
    return request({
      url: '/user/set/ga',
      method: 'post',
      data,
    });
  },
  // 查看谷歌验证器
  checkGoogleVerify(code) {
    return request.get('/api/u/ga/select', {
      params: {
        code,
      },
    });
  },
  // 关闭谷歌验证
  closeGoogleVerify(data) {
    return request({
      url: '/api/u/ga/cancel',
      method: 'post',
      data,
    });
  },
  /*
    绑定邮箱
    data => {
      email: "",
      validateCode: "",
      ga_code: ""
    }
   */
  bindEmail(data) {
    return request({
      url: '/api/u/user/bindingEmail',
      method: 'post',
      data,
    });
  },
  /*
   绑定手机
    data => {
      countryCode: "+86",// 城市代码，如+86
      mobile: "",// 手机号
      validateCode: "",// 短信验证码
      ga_code// 谷歌验证码(未绑定谷歌验证器则不需要)
    }
    */
  bindMobile(data) {
    const url = '/user/bind/phone';
    return request({
      url: url,
      method: 'post',
      data,
    });
  },
  /*
   修改手机
    data => {
      "countryCode": // 城市代码，如+86
      "newMobilePhone": // 手机号
      "oldValidateCode": // 旧手机手机验证码
      "validateCode": // 新手机手机验证码
      ga_code: ""// 谷歌验证码
    }
    */
  modifyMobile(data) {
    const url = '/user/unbind/phone';
    return request({
      url: url,
      method: 'put',
      data,
    });
  },
  /*
   设置交易密码
   data => {
    payPassword // 交易密码
    ga_code // 谷歌验证码
   }
    */
  setTxPassword(data) {
    let { password, gaCode } = data;
    password = md5(password);
    return request({
      url: '/user/set/txn-pwd',
      method: 'post',
      data: {
        password,
        gaCode,
      },
    });
  },
  /*
   修改交易密码
   data => {
    payPassword // 交易密码
    oldPassword // 旧交易密码
    ga_code // 谷歌验证码
   }
    */
  updateTxPassword(data) {
    let { newPassword, oldPassword, gaCode } = data;
    newPassword = md5(newPassword);
    oldPassword = md5(oldPassword);
    return request({
      url: '/user/upd/txn-pwd',
      method: 'put',
      data: {
        newPassword,
        oldPassword,
        gaCode,
      },
    });
  },
  setLoginPwd(data) {
    return request({
      url: '/user/set/pwd',
      method: 'post',
      data: {
        password: md5(data.password),
        gaCode: data.gaCode,
      },
    });
  },
  /*
    修改登录密码
    data => {
      newPassword
      oldPassword
      ga_code
      validateCode
    }
   */
  modifyLoginPwd(data) {
    return request({
      url: '/user/upd/pwd',
      method: 'put',
      data: {
        newPassword: md5(data.newPassword),
        oldPassword: md5(data.oldPassword),
        // emailCode: data.validateCode,
        gaCode: data.gaCode,
      },
    });
  },
  getMyReferralCode() {
    return request.get('/user/get/ref');
  },
  setReferral(data) {
    return request({
      url: '/user/set/ref',
      method: 'post',
      data,
    });
  },
  setCompanyAsReferral() {
    return request({
      url: '/user/set/def-ref',
      method: 'post',
      data: {},
    });
  },
  setUnbindGA(data) {
    return request({
      url: '/user/reset/ga',
      method: 'post',
      data,
    });
  },
  /**
   * 获取我邀请的用户
   * @param current
   * @param size
   * @returns {Promise<AxiosResponse<T>>}
   */
  getMyReferral(current, size) {
    return request.get('/user/get/ref-list', {
      params: {
        current,
        size,
      },
    });
  },
  /**
   * 获取邀请规则说明
   * @returns {Promise<AxiosResponse<T>>}
   */
  getReferralRules() {
    return request.get('/api/u/user/referralActivity', {
      params: {
        current: 1,
        size: 1,
      },
    });
  },
  getAllTransactions(current, size, start, end, coindId) {
    return request.get('/gw/w/account/detail', {
      params: {
        size: size,
        current: current,
        begin_date: start,
        end_date: end,
        coinId: coindId,
        assetType: 1
      },
    });
  },
  /**
   * 设置防钓鱼码
   * data => {
      "antiFishing": '', // 防钓鱼码
      "emailCode": '', // 邮箱验证码
      "ga_code": '' // 谷歌验证码
   * }
   */
  setAntFishing(data) {
    return request.post('/api/u/user/security/setAntiFishing', data);
  },
  /**
   * 修改防钓鱼码
   * data => {
      "newAntiFishing": '', // 新防钓鱼码
      "oldAntiFishing": '', //旧防钓鱼码
      "emailCode": '', // 邮箱验证码
      "ga_code": '' // 谷歌验证码
   * }
   */
  modifiyAntFishing(data) {
    return request.post('/api/u/user/security/modifyAntiFishing', data);
  },
  getAffiliateAndPartnerInfo() {
    return request.get('/gw/a/info');
  }
};
